import { Injectable } from '@angular/core';
import { IAddressModel } from 'src/app/people/models/addressModel';
import { PortalBaseService } from 'src/portal/portal-base.service';

@Injectable({
  providedIn: 'root',
})
export class AddressService extends PortalBaseService {
  constructor() {
    super();
  }

  public validate = (
    address: IAddressModel,
    addressValidationCacheKey: string
  ): Promise<IAddressValidationResult> =>
    this.post(
      'address/validate',
      { ...address, addressValidationCacheKey: addressValidationCacheKey },
      null
    ).toPromise<IAddressValidationResult>();
}
export type AddressValidationStatus = 'Success' | 'Warning' | 'Error';
export interface IAddressValidationResult {
  status: AddressValidationStatus;
  message: string;
  correctedAddress: IAddressModel;
  addressValidationCacheKey: string;
}
